import { CRM_LEAD_VK_META_EMPTY } from '@/api/types/crm/crmLeadFunnels.types'
import type { LeadField, LeadState } from '@/api/types/crm/crm.types'
import type { LeadsTableRow } from '@pages/Admin/CRM/utils/mapLeadsToTableRows'
import type { KanbanCardSyncDataDto } from '../store/kanban.types'

export type KanbanFunnelListRowContext = {
  funnelName: string
  statusName: string
  statusColor: string
  leadState?: LeadState
  fields?: LeadField[]
}

/** Минимальная строка get-leads для EditEntityModal / LeadProfileModal (после insert + getCard). */
export function buildFunnelListRowFromKanbanSync(
  data: KanbanCardSyncDataDto,
  ctx: KanbanFunnelListRowContext,
): LeadsTableRow {
  const funnelId = data.funnel_id
  const manager =
    data.manager?.id != null && Number.isFinite(Number(data.manager.id))
      ? {
          id: Number(data.manager.id),
          name: String(data.manager.name ?? '').trim(),
          fio: String(data.manager.name ?? '').trim(),
        }
      : null

  return {
    lead_funnel_id: data.lead_funnel_id,
    lead: {
      id: data.lead_id,
      name: data.name ?? '',
      phone: String(data.phone ?? ''),
      email: '',
    },
    funnel: { id: funnelId, name: ctx.funnelName },
    current_status: {
      id: data.status_id,
      name: ctx.statusName,
      color: ctx.statusColor,
    },
    funnels: [
      {
        id: funnelId,
        name: ctx.funnelName,
        isPrimary: true,
        manager_id: manager?.id ?? null,
      },
    ],
    fields: ctx.fields ?? [],
    manager,
    next_contact_date: data.next_contact_at,
    is_primary: true,
    type: ctx.leadState ?? 'new',
    traffic_channel: null,
    user_id: null,
    user: null,
    is_duplicate: false,
    last_duplicated_lead: null,
    vk: data.vk ?? CRM_LEAD_VK_META_EMPTY,
    integrations: data.integrations ?? {
      vkontakte: data.vk ?? CRM_LEAD_VK_META_EMPTY,
    },
    created_at: data.updated_at ?? new Date().toISOString(),
    id: data.lead_id,
    rowId: String(data.lead_funnel_id),
    currentFunnelId: funnelId,
    currentFunnelStatusId: data.status_id,
    currentFunnelStatusName: ctx.statusName,
    currentFunnelStatusColor: ctx.statusColor,
  }
}
